export default __webpack_public_path__ + "static/media/NancyImg.27681f7b.png";